import React, { useEffect } from 'react';

const PreloadImage = ({ src, alt }) => {
    useEffect(() => {
        const img = new Image();
        img.src = src;
    }, [src])

    return <img className='preloadimage' src={src} alt={alt} />
}

export default PreloadImage;